import { psAxios } from '@patsnap/common-ps-http';
import { getFingerprint } from '../../utils/fingerprint';

const CLIENT_NAME = import.meta.env.VITE_PASSPORT_CLIENT_NAME;

let _header = {};

/**
 * 设置项目请求的 header
 * @param headers
 */
export function setProjectRequestHeaders(headers: Record<string, unknown>): void {
    _header = headers;
}

/**
 * 项目请求拦截器
 * @description 添加 X-PatSnap-From header 和开发环境的模拟用户身份
 */
export const projectRequestInterceptor = async(config: any) => {
    if (config.headers) {
        config.headers['X-PatSnap-From'] = `w-${CLIENT_NAME}`;
    }
    // 开发环境专用：模拟用户身份，生产环境会被编译器移除
    if (import.meta.env.DEV) {
        if (config.baseURL === 'http://127.0.0.1:8080/telecom') {
            config.headers = config.headers || {};
            const CZQ_SUB_ID = 'd7cd0ffe1ff6472583181f5d02157c05';
            config.headers['X-User-Id'] = CZQ_SUB_ID;
            // config.headers['X-User-Roles'] = '...';
        }
    }
    config.headers = {
        ...config.headers,
        ..._header,
    };

    return config;
};

/**
 * 注入项目请求拦截器
 */
export function injectProjectRequestInterceptor() {
    if (!psAxios.psInterceptors.projectRequestInterceptor) {
        psAxios.psInterceptors.projectRequestInterceptor = psAxios.interceptors.request.use(
            projectRequestInterceptor,
            undefined,
        );
    }
}

/**
 * 移除项目请求拦截器
 */
export function ejectProjectRequestInterceptor() {
    if (psAxios.psInterceptors.projectRequestInterceptor) {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.projectRequestInterceptor);
        delete psAxios.psInterceptors.projectRequestInterceptor;
    }
}
